import { Component, OnInit } from '@angular/core';
import { ForgotpasswordquestionsService } from './forgotpasswordquestions.service';
import { HttpParams } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import{ Modal } from 'bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RsaService } from '../common_services/encryptutil.service';

declare var jQuery: any;

@Component({
    selector: 'app-forgotpassword',
    templateUrl: './forgotpasswordquestions.component.html',
    styleUrls: ['./forgotpasswordquestions.component.scss'],
    standalone: false
})
export class ForgotpasswordquestionsComponent implements OnInit {
    private unsubscribe$ = new Subject<void>();
    userName: any;
    LoginErrorMessage: any;
    questionResponse: any;
    errorMessage: any;
    news = [];
    loading = false;
    constructor(private router: Router, private route: ActivatedRoute, 
        private questionService: ForgotpasswordquestionsService, 
        private encryptService : RsaService) { }

    ngOnInit() {
        this.checkUserLogin();
        this.questionResponse = { questions: [] };
        this.route.params.subscribe(params => {
            this.userName = params['userName'];
        });
        this.loadQuestions(this.userName);

        const questions = this.questionResponse.questions;
        this.getNews();

    }
    checkUserLogin() {
    }
    onInputFocus(event: any, index: number) {
        this.hideValidate(event.target.name, index);
    }
    hideValidate(inputName: string, index: number) {
        const questions = this.questionResponse.questions;
        questions[index].isValidAnswer = true;
    }
    onSubmit() {
        this.errorMessage = '';
        this.loading = true;
        const questions = this.questionResponse.questions;
        let hasAllAnswers = true;
        for (let i = 0; i < questions.length; i++) {
            if (questions[i].answer === undefined || questions[i].answer === '') {
                questions[i].isValidAnswer = false;
                hasAllAnswers = false;
                this.loading = false;
            }
        }
        if (!hasAllAnswers) {
            return;
        }
        this.questionService.validateQuestion(this.questionResponse).
        pipe(takeUntil(this.unsubscribe$)).subscribe(
                (resp) => {
                    this.showNewPasswordPage(resp['key']);
                    this.questionService.setUserNameFromUrl(this.userName);
                    this.loading = false;
                    return;
                },
                err => {
                    this.errorMessage = 'Failed to validate your answer. Please try again';
                    this.openModal('myModal');
                    this.loading = false;
                    return;
                }
            );
    }

    loadQuestions(userName) {
        this.loading = true;
        this.questionResponse = this.encryptService.getQuestionResponse()
        this.loading = false;
    

    }

    showNewPasswordPage(key): void {
        this.router.navigate(['./resetpassword', { key: key }]);
    }
    getNews() {
        this.loading = true;
        this.questionService.getNews((success: boolean, news: any) => {
            if (success) {
                this.news = news['providerPortalBroadcast'];
                this.loading = false;
            } else {
                this.loading = false;
            }
        });

    }
    openModal(modalId: any) {
        const modal = new Modal(document.getElementById(modalId));
        modal.show();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
